// CSS class names that the DataGrid theme styles and column-level
// cellClassName helpers can apply.

// Marks a grouping cell whose group represents an "empty"-like bucket:
// null values, or domain-specific synthetic buckets (e.g. Learning's
// special:NOBODY / special:EVERYBODY).
export const GROUP_EMPTY_CELL_CLASS = 'GuavaGrid-groupEmpty';
